import Vue from 'vue'
import { getterTree, mutationTree, actionTree } from 'typed-vuex'
import { ALL_TAB, EASY_APPLY_TAB, IGNORED_TAB, PICKED_TAB, SENT_TAB, STARTED_TAB } from '~/store/sideBar'
import { sortMethods } from '~/lib/utils/sorting'
import { Store } from '~/types/store'
import { getKeys } from '~/lib/utils/utils'

export const state = () => ({
  [ALL_TAB]: { sort: {} as Store.Sorting.SortingRule },
  [PICKED_TAB]: { sort: {} as Store.Sorting.SortingRule },
  [STARTED_TAB]: { sort: {} as Store.Sorting.SortingRule },
  [SENT_TAB]: { sort: {} as Store.Sorting.SortingRule },
  [IGNORED_TAB]: { sort: {} as Store.Sorting.SortingRule },
  [EASY_APPLY_TAB]: { sort: {} as Store.Sorting.SortingRule }
})

export const getters = getterTree(state, {
  getSort(state) {
    return (tabName: Store.SortingTab): Partial<Store.Sorting.SortingRule> => {
      if (!tabName) { return {} }
      return state[tabName] ? state[tabName].sort : {}
    }
  },
  isSortableTab: (_state, _getters, rootState) => {
    return [
      'matches',
      'saved',
      'started',
      'submitted',
      'ignored',
      'easy'
    ].includes(rootState.route.params.tabName)
  },
  isSortApplied(state, getters, rootState) {
    return !!Object.keys(getters.getSort(rootState.route.params.tabName)).length
  },
  sortedList(state, getters, rootState, rootGetters) {
    return (list) => {
      const tabName = rootState.route.params.tabName
      const { sortField, sortDir }: Store.Sorting.SortingRule = rootGetters['sorting/getSort'](tabName)

      if (!(sortField && sortDir)) { return list }

      const area = tabName === 'submitted' ? 'submitted' : 'default'

      // @ts-ignore
      if (sortField === 'magic') {
        list = sortMethods[area][sortField](list, sortDir, rootState.eligibleSorted.eligibleSortedScholarships)
      } else {
        list = [...sortMethods[area][sortField](list, sortDir)]
      }

      return list
    }
  }
})

export const mutations = mutationTree(state, {
  addSorting(state, { tabName, sortDir, sortField }: { tabName: Store.SortingTab, sortDir: Store.Sorting.Order, sortField: Store.Sorting.Sorting }) {
    Vue.set(state[tabName], 'sort', { sortDir, sortField })
  },
  removeSorting(state, { tabName }: { tabName: Store.SortingTab }) {
    Vue.set(state[tabName], 'sort', {})
  }
})

export const actions = actionTree(
  { state, getters, mutations },
  {
    applySorting({ rootState, commit }, { tabName, sortDir, sortField }) {
      tabName = tabName || rootState.route.params.tabName
      commit('addSorting', { tabName, sortDir, sortField })
    },
    removeSorting({ rootState, commit }, { tabName }) {
      tabName = tabName || rootState.route.params.tabName
      commit('removeSorting', { tabName })
    },
    removeAllSort({ state, commit }) {
      for (const tabName of getKeys(state)) {
        commit('removeSorting', { tabName })
      }
    }
  }
)
